module.exports = __webpack_public_path__ + "img/01.02b77366.png";